// extracted by mini-css-extract-plugin
export default {"botao":"Botao_botao__XLWAF"};